import {
  CashReceivingRequest,
  KioskSdkOptions,
  PrintReceiptRequest
} from '@b2bsoft/kiosk-common-sdk/dist/interfaces'
import * as startShellProcessingCash from './methods/StartProcessingCash'
import * as printShellReceipt from './methods/PrintReceipt'
import * as fillStack from './methods/FillStack'
import StoreModel from 'models/Index'
import { history } from 'helpers/History'

export function startProcessingCash(
  store: StoreModel,
  request: CashReceivingRequest,
  options?: KioskSdkOptions
) {
  return startShellProcessingCash.default(store, { data: request })
}

export function goHome() {
  history.push({ pathname: '/', search: history.location.search })
}

export function goApplicationSelect() {
  history.push({ pathname: '/applications', search: history.location.search })
}

export function goBack(store: StoreModel) {
  if (store.common.hasMultiplyApplications) {
    return history.goBack()
  }

  history.push({ pathname: '/', search: history.location.search })
}

export function printReceipt(store: StoreModel, request: PrintReceiptRequest) {
  return printShellReceipt.default(store, { data: request });
}

export function fillSdkStack(store: StoreModel, data: any) {
  return fillStack.default(store, data);
}